import { Injectable, inject, signal } from '@angular/core';
import { PromotionsApiService } from '../api/promotions-api.service';
import { dtoAOferta, ofertaADto, tipoOfertaADto } from '../api/promotions.mapper';
import {
  Oferta,
  OfertaEdicionRapida,
  OfertaFormValue,
  SucursalOferta,
  TipoOferta,
} from '../models/promociones.model';
import { SucursalesService } from './sucursales.service';

@Injectable({ providedIn: 'root' })
export class OfertasService {
  private api = inject(PromotionsApiService);
  private sucursalesService = inject(SucursalesService);

  readonly ofertas = signal<Oferta[]>([]);

  constructor() {
    this.cargar('dos-en-uno');
    this.cargar('dos-por-uno');
  }

  cargar(tipo: TipoOferta): void {
    this.api.listarOfertas(tipoOfertaADto(tipo)).subscribe({
      next: (lista) => {
        const frescas = lista.map(dtoAOferta);
        this.ofertas.update((actuales) => [
          ...frescas,
          ...actuales.filter((o) => o.tipo !== tipo),
        ]);
      },
      error: (error) =>
        console.error(`[Promociones] No se pudieron cargar las ofertas ${tipo}`, error),
    });
  }

  porTipo(tipo: TipoOferta): Oferta[] {
    return this.ofertas().filter((o) => o.tipo === tipo);
  }

  sucursalesPorDefecto(): SucursalOferta[] {
    return this.sucursalesService.paraOferta();
  }

  obtenerPorId(id: string): Oferta | undefined {
    return this.ofertas().find((o) => o.id === id);
  }

  crear(form: OfertaFormValue, tipo: TipoOferta): void {
    this.api.crearOfertas(tipoOfertaADto(tipo), ofertaADto(form, tipo)).subscribe({
      next: () => this.cargar(tipo),
      error: (error) => console.error('[Promociones] No se pudo crear la oferta', error),
    });
  }

  actualizar(id: string, cambios: OfertaEdicionRapida): void {
    const oferta = this.obtenerPorId(id);
    if (!oferta) return;

    const dosEnUno = oferta.tipo === 'dos-en-uno';

    this.api
      .editarOferta(tipoOfertaADto(oferta.tipo), id, {
        buyQuantity: cambios.compra,
        getQuantity: dosEnUno ? null : cambios.valor,
        offerPrice: dosEnUno ? cambios.valor : null,
        maxQuantity: cambios.cantidadMaxima,
        stock: cambios.stock,
      })
      .subscribe({
        next: () => this.cargar(oferta.tipo),
        error: (error) => console.error('[Promociones] No se pudo actualizar la oferta', error),
      });
  }

  eliminar(id: string): void {
    const oferta = this.obtenerPorId(id);
    if (!oferta) return;

    this.api.eliminarOferta(tipoOfertaADto(oferta.tipo), id).subscribe({
      next: () => this.cargar(oferta.tipo),
      error: (error) => console.error('[Promociones] No se pudo eliminar la oferta', error),
    });
  }
}
